<template>
  <b-container>
    <div>
      <div>
        <div class="row no-gutters">
          <div id="col-left-with-text" class="col-sm-12 col-md-12 col-lg-4 ">
            <div class="w-100">

              <div class="mt-5 mb-2">
                <img class="logo-img" :src="require(`@/assets/images/b122/logo.png`)" alt="Logo Login">
              </div>

              <login-component
                v-if="showLoginComponent"
                @showForgotPasswordView="showForgotPasswordView"
                @showSmsCodeView="showSmsCodeView"/>

              <sms-code-component
                v-if="showSmsCodeComponent"
                ref="smsCodeComponent"
                @showLoginView="showLoginView"/>

              <validate-account-component
                v-if="showValidateAccountComponent"
                @showLoginView="showLoginView"/>

              <forgot-password-component
                v-if="showForgotPasswordComponent"
                @showLoginView="showLoginView"/>

              <reset-password-component
                v-if="showResetPasswordComponent"
                @showLoginView="showLoginView"/>

              <validate-account-and-password-component
                v-if="showValidateAccountAndPasswordComponent"
                @showLoginView="showLoginView"/>

            </div>
          </div>
          <div id="col-right-with-image" class="col-sm-12 col-md-12 col-lg-8 d-flex flex-row"
               :style="{'background-image': 'url(' + require(`@/assets/images/b122/login-background.jpeg`) + ')'}"></div>
          <div class="login-picture-credit">Robustagno-CIIRPO</div>
        </div>

      </div>
    </div>

  </b-container>
</template>

<script>

import i18n from '../../i18n'
import LoginComponent from './components/LoginComponent'
import ValidateAccountAndPasswordComponent from './components/ValidateAccountAndPasswordComponent'
import ForgotPasswordComponent from './components/ForgotPasswordComponent'
import ValidateAccountComponent from './components/ValidateAccountComponent'
import SmsCodeComponent from './components/SmsCodeComponent'
import ResetPasswordComponent from './components/ResetPasswordComponent'

export default {

  name: 'Login',

  components: {
    ResetPasswordComponent,
    SmsCodeComponent,
    ValidateAccountComponent,
    ForgotPasswordComponent,
    LoginComponent,
    ValidateAccountAndPasswordComponent,
    i18n
  },

  data () {
    return {
      currentComponent: this.$route.params.component
    }
  },

  computed: {
    showLoginComponent () {
      return this.currentComponent ? this.currentComponent === 'login' : true
    },
    showSmsCodeComponent () {
      return this.currentComponent === 'smsCode'
    },
    showValidateAccountComponent () {
      return this.currentComponent === 'validateAccount'
    },
    showForgotPasswordComponent () {
      return this.currentComponent === 'forgotPassword'
    },
    showResetPasswordComponent () {
      return this.currentComponent === 'resetPassword'
    },
    showValidateAccountAndPasswordComponent () {
      return this.currentComponent === 'validateAccountAndPassword'
    }
  },

  mounted () {
    if (localStorage.locale != null) {
      this.$i18n.locale = localStorage.locale
    }
  },

  methods: {

    showLoginView () {
      this.currentComponent = 'login'
    },
    showSmsCodeView (username, password, phoneNumber) {
      this.currentComponent = 'smsCode'
      this.$refs.smsCodeComponent.username = username
      this.$refs.smsCodeComponent.password = password
      this.$refs.smsCodeComponent.phoneNumber = phoneNumber
    },
    showForgotPasswordView () {
      this.currentComponent = 'forgotPassword'
    }

  }

}

</script>

<style scoped>

b-container {
  padding: 0;
}

.container {
  padding: 0;
}

#col-right-with-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: center;
  height: 100vh;
}

#col-left-with-text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 100px;
  padding-left: 100px;
  height: 100vh;
  background-color: white;
}

@media (max-width: 992px) {
  #col-right-with-image {
    display: none !important;
  }
  .login-picture-credit {
    display: none !important;
  }
}

@media (max-width: 500px) {
  #col-left-with-text {
    padding-right: 40px;
    padding-left: 40px;
  }
}

@media (max-height: 700px) {
  #col-left-with-text {
    height: auto;
  }
}

.logo-img {
  max-height: 140px;
}

h1 {
  font-size: var(--page-title-medium-font-size);
}

h2 {
  font-size: var(--subtitle-font-size);
}

a {
  color: var(--main-green-light);
}

</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue